import { render } from "./AttendanceAdjustment.vue?vue&type=template&id=505351f4&scoped=true"
import script from "./AttendanceAdjustment.vue?vue&type=script&lang=js"
export * from "./AttendanceAdjustment.vue?vue&type=script&lang=js"

import "./AttendanceAdjustment.vue?vue&type=style&index=0&id=505351f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505351f4"]])

export default __exports__